module.exports = require("assert");